import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ymKey } from '../config/metric';

export const YandexMetrika = () => {
    const location = useLocation();

    useEffect(() => {
        if (window.ym) {
            window.ym(
                ymKey,
                'hit',
                location.pathname + location.search
            );
        }
    }, [location]);

    return null;
};